import cx from 'classnames'
import { useMemo } from 'react'

import { type SanityNestedSimpleGridBlock } from '@data/sanity/queries/types/blocks'

import NestedSimpleGridBlock from './nested-simple-grid-block'

type NestedSimpleGridProps = Pick<SanityNestedSimpleGridBlock, 'blocks'>

const NestedSimpleGrid = ({ blocks }: NestedSimpleGridProps) => {
  const filteredBlocks = useMemo(() => {
    return blocks?.filter((block) => {
      // Exclude product cards with draft or deleted products
      if (
        block._type === 'productCard' &&
        (!block.product ||
          block.product.isDraft ||
          block.product.wasDeleted ||
          block.product.notAvailable)
      ) {
        return false
      }

      return true
    })
  }, [blocks])

  const rowCount = useMemo(() => {
    const blockCount = blocks?.length ?? 0
    return Math.ceil(blockCount / 2)
  }, [blocks])

  return (
    <div
      className="grid grid-cols-2 h-full"
      style={{
        gridTemplateRows:
          rowCount > 0 ? `repeat(${rowCount}, minmax(0, 1fr))` : undefined,
      }}
    >
      {filteredBlocks?.map((block) => (
        <div
          key={block._key}
          className={cx({
            'px-3 py-5': block._type === 'freeform',
          })}
        >
          <NestedSimpleGridBlock block={block} />
        </div>
      ))}
    </div>
  )
}

export default NestedSimpleGrid
